module.exports = __webpack_public_path__ + "88ca24f35625a2d4ccda68c9c470bb10.svg";